import React, { useCallback, useEffect, useState, lazy, memo } from 'react';
import { CheckIcon, PackageIcon, TagIcon, ChevronLeftIcon, ChevronRightIcon, ArrowRightIcon } from 'lucide-react';
const BonusCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const bonuses = [{
    id: 1,
    title: 'BONO #1 – Recetario de salsas y aderezos express',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/s7a4btKWjVnTrCKP3TyhKz/Bono_1_Recetario_de_Salsas.png',
    features: ['15+ recetas listas en 5 min o menos', 'Sin conservantes ni aditivos', 'Salsas caseras que elevan cualquier plato']
  }, {
    id: 2,
    title: 'BONO #2 – Guía de snacks saludables para toda la familia',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6JiuTXN7Eo8yXhaQH4FHQ4/Bono_2_-_Guia_de_Snack_Saludables.png',
    features: ['Opciones dulces y saladas sin azúcar refinada', 'Gustan a niños y adultos', 'Meriendas prácticas entre comidas']
  }, {
    id: 3,
    title: 'BONO #3 – Planificador de compras inteligente',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8Rx6yPHJpCkb9Q48z3yM1Z/Bono_3_-_Planificador_inteligente.png',
    features: ['Ahorra hasta 30% con estrategia', 'Plantillas editables e imprimibles', 'Organiza tus compras por secciones']
  }, {
    id: 4,
    title: 'BONO #4 – Ebook de postres saludables sin horno',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3YkeUnSbFuXuN9EVU5gCj5/Bono_4_-_postres_saludables_sin_horno.png',
    features: ['Recetas sin horno, rápidas y fáciles', 'Con ingredientes naturales', 'Bajos en azúcar y 100% deliciosos']
  }, {
    id: 5,
    title: 'BONO #5 – Mini guía de batch cooking en 2 horas',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oZJq2UkbEnSJ5uUMq3Escx/Bono_5_-_Mini_batch_cooking.png',
    features: ['Plan paso a paso para cocinar en lotes', 'Conserva tus alimentos por más tiempo', 'Menú semanal listo en 2 horas']
  }];
  const nextSlide = useCallback(() => {
    setCurrentSlide(prev => prev === bonuses.length - 1 ? 0 : prev + 1);
  }, [bonuses.length]);
  const prevSlide = useCallback(() => {
    setCurrentSlide(prev => prev === 0 ? bonuses.length - 1 : prev - 1);
  }, [bonuses.length]);
  const handleTouchStart = e => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swipe left
      nextSlide();
    }
    if (touchStart - touchEnd < -50) {
      // Swipe right
      prevSlide();
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);
  const scrollToOffer = () => {
    const offerSection = document.getElementById('pricing-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full" data-id="element-201">
      <h4 className="text-lg font-bold text-[#438A52] mb-4 text-center" data-id="element-202">
        🎁 También recibes estos bonos exclusivos:
      </h4>
      <div className="relative w-full overflow-hidden" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-203">
        <div className="flex transition-transform duration-300 ease-in-out" style={{
        transform: `translateX(-${currentSlide * 100}%)`
      }} data-id="element-204">
          {bonuses.map(bonus => <div key={bonus.id} className="w-full flex-shrink-0 px-2" data-id="element-205">
              <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100" data-id="element-206">
                <div className="h-48 bg-[#FAFFFB] flex items-center justify-center p-4" data-id="element-207">
                  <img src={bonus.image} alt={`Imagen de ${bonus.title}`} className="h-full object-contain" data-id="element-208" />
                </div>
                <div className="p-4" data-id="element-209">
                  <h5 className="font-bold text-[#438A52] mb-3 text-center" data-id="element-210">
                    {bonus.title}
                  </h5>
                  <ul className="space-y-2 mb-4" data-id="element-211">
                    {bonus.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-212">
                        <CheckIcon className="w-5 h-5 text-[#438A52] mt-1 mr-2 flex-shrink-0" data-id="element-213" />
                        <span className="text-sm" data-id="element-214">{feature}</span>
                      </li>)}
                  </ul>
                  <button className="w-full py-2 px-4 bg-[#DEEFE1] text-[#438A52] font-medium rounded-md text-sm" data-id="element-215">
                    Incluido sin costo
                  </button>
                </div>
              </div>
            </div>)}
        </div>
        {/* Navigation dots */}
        <div className="absolute bottom-2 left-0 right-0 flex justify-center space-x-2" data-id="element-216">
          {bonuses.map((_, idx) => <button key={idx} onClick={() => setCurrentSlide(idx)} className={`w-2 h-2 rounded-full ${idx === currentSlide ? 'bg-[#438A52]' : 'bg-gray-300'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-217" />)}
        </div>
        {/* Navigation buttons */}
        <button onClick={prevSlide} className="absolute top-1/2 left-2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md" aria-label="Previous slide" data-id="element-218">
          <ChevronLeftIcon className="w-5 h-5 text-[#438A52]" data-id="element-219" />
        </button>
        <button onClick={nextSlide} className="absolute top-1/2 right-2 -translate-y-1/2 bg-white/80 p-2 rounded-full shadow-md" aria-label="Next slide" data-id="element-220">
          <ChevronRightIcon className="w-5 h-5 text-[#438A52]" data-id="element-221" />
        </button>
      </div>
      <div className="mt-6 text-center" data-id="element-222">
        <button onClick={scrollToOffer} className="inline-flex items-center justify-center bg-[#FF6B3C] hover:bg-[#E05A30] text-white font-bold py-3 px-6 rounded-lg text-lg transition duration-300 shadow-lg" data-id="element-223">
          ¡Obtén todo sin pagar extra!{' '}
          <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-224" />
        </button>
      </div>
    </div>;
};
const Offer = () => {
  const handlePurchaseClick = useCallback(() => {
    // Track purchase button click with Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        value: 7.19,
        currency: 'USD',
        content_name: 'La Cena Que Te Salva'
      });
    }
  }, []);
  return <div id="offer-section" className="w-full bg-white py-16" data-id="element-225">
      <div className="container mx-auto px-4" data-id="element-226">
        <div className="text-center mb-12" data-id="element-227">
          <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-228">
            Recibe TODO este sistema completo en un solo paquete digital
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto" data-id="element-229">
            Cenas fáciles, nutritivas y organizadas desde esta misma noche.
          </p>
        </div>

        <div className="max-w-5xl mx-auto mb-12" data-id="element-230">
          <div className="bg-[#FAFFFB] rounded-xl shadow-xl p-8" data-id="element-231">
            {/* Etiqueta arriba de la imagen */}
            <div className="mb-4 flex items-center justify-center gap-2" data-id="element-232">
              <span className="inline-flex items-center gap-2 bg-[#FF6B35] text-white font-bold py-2 px-6 rounded-full shadow-lg" data-id="element-233">
                <TagIcon className="w-5 h-5" data-id="element-234" />
                ¡OFERTA COMPLETA!
              </span>
            </div>

            {/* Imagen */}
            <div className="rounded-lg overflow-hidden" data-id="element-235">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w37Hvk3qXAMpiyFQA7kgWg/custompic.jpg" alt="Vista previa del paquete digital La Cena Que Te Salva con todos los bonos" className="w-full h-auto object-cover" loading="lazy" data-id="element-236" />
            </div>

            {/* Cuadro verde debajo de la imagen */}
            <div className="mt-4 bg-[#438A52] text-white font-bold py-3 px-4 rounded-lg shadow-md text-center" data-id="element-237">
              <PackageIcon className="w-5 h-5 inline-block mr-2 align-middle" data-id="element-238" />
              Valor total: <span className="line-through" data-id="element-239">$77.95</span> → $7.19
              hoy
            </div>

            {/* CTA principal */}
            <div className="mt-6 text-center" data-id="element-240">
              <a href="https://pay.hotmart.com/W102040249E?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#FF6B3C] hover:bg-[#E05A30] text-white font-bold py-3 px-8 rounded-lg text-lg transition duration-300 shadow-lg" onClick={handlePurchaseClick} data-id="element-241">
                ¡Accede ahora mismo por solo $7.19!
              </a>
            </div>

            {/* Lista de contenidos */}
            <div className="mt-8 text-center" data-id="element-242">
              <p className="text-xl font-bold text-[#438A52] mb-2" data-id="element-243">
                Sistema completo con todo lo que necesitas:
              </p>

              <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-244">
                <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-245">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qviNynnFHmdKTY9apo66gZ/Solo_caratula_La_Cena_que_te_salva.jpg" alt="La Cena Que Te Salva ebook" className="w-full md:w-40 h-auto object-cover rounded" loading="lazy" width="160" height="220" data-id="element-246" />
                  <div className="text-left" data-id="element-247">
                    <h3 className="text-xl font-bold text-[#438A52] mb-2" data-id="element-248">
                      Ebook "La Cena Que Te Salva"
                    </h3>
                    <ul className="space-y-2" data-id="element-249">
                      <li className="flex items-start" data-id="element-250">
                        <CheckIcon className="w-5 h-5 text-[#438A52] mt-1 mr-2 flex-shrink-0" data-id="element-251" />
                        <span data-id="element-252">
                          10 recetas latinas auténticas listas en 30 minutos o
                          menos
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-253">
                        <CheckIcon className="w-5 h-5 text-[#438A52] mt-1 mr-2 flex-shrink-0" data-id="element-254" />
                        <span data-id="element-255">Plan completo de comidas para 2 semanas</span>
                      </li>
                      <li className="flex items-start" data-id="element-256">
                        <CheckIcon className="w-5 h-5 text-[#438A52] mt-1 mr-2 flex-shrink-0" data-id="element-257" />
                        <span data-id="element-258">Lista de compras editable e imprimible</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <BonusCarousel data-id="element-259" />

              <div id="pricing-section" className="bg-[#DEEFE1] p-6 rounded-lg shadow-md my-8" data-id="element-260">
                <div className="text-center" data-id="element-261">
                  <p className="text-lg mb-2" data-id="element-262">
                    💥 Precio normal:{' '}
                    <span className="line-through" data-id="element-263">$19.99</span>
                  </p>
                  <p className="text-3xl font-bold text-[#438A52] mb-2" data-id="element-264">
                    🎉 Precio de lanzamiento: $7.19
                  </p>
                  <p className="text-md font-medium text-[#FF6B3C]" data-id="element-265">
                    Ahorra más de $70 hoy
                  </p>
                </div>
              </div>

              <a href="https://pay.hotmart.com/W102040249E?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#FF6B3C] hover:bg-[#E05A30] text-white font-bold py-4 px-10 rounded-lg text-xl transition duration-300 shadow-lg w-full md:w-auto" onClick={handlePurchaseClick} data-id="element-266">
                ¡Accede ahora mismo por solo $7.19!
              </a>
              <p className="mt-4 text-sm text-gray-600" data-id="element-267">
                Acceso instantáneo • Sin suscripción • Pago único
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default memo(Offer);